import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { cloneDeep } from 'src/ep-utils';
import { TaskObjectService } from '../../models/proprietary/task/task-object.service';
import { AppService } from './app.service';
import { DataService } from './data.service';
import { Datasource, DataSourceStatus } from './datasource';

export class ZipCodeAltCitiesType {
    City: string[];
}

export class ZipCodeType {
    Zip_Code?: string;
    City?: string;
    County?: string;
    State?: string;
    State_Desc?: string;
    Country?: string;
    Country_Desc?: string;
    Alt_Cities?: ZipCodeAltCitiesType;
    Zip_Lookup_Status?: string;
    Zip_Lookup_Message?: string;
}

@Injectable({
    providedIn: 'root'
})
export class ZipCodeService implements OnDestroy {
    private dsZipCode: Datasource;

    zipCodeGetSub: Subscription;
    zipCodeGetStatus$: Observable<DataSourceStatus>;

    constructor(private app: AppService, private ds: DataService, private taskOS: TaskObjectService) {
        this.dsZipCode = ds.addNewDatasource('ZipCode');
        this.dsZipCode.showErrors = false; //don't show errors message in UI when zip lookup fails.
    }

    ngOnDestroy() {
        if (this.zipCodeGetSub) {
            this.zipCodeGetSub.unsubscribe();
        }
    }

    // the function passed in the callback parameter will be called once the zip lookup is complete.  
    // The function should have one parameter of ZipCodeType
    lookupZip(zipcode: string, callback: any = null) {
        if (this.zipCodeGetSub) {
            this.zipCodeGetSub.unsubscribe();
        }
        this.dsZipCode.get({ Zip_Code: zipcode, View: 'Full', json: 'CT2' });
        this.zipCodeGetSub = this.dsZipCode.status$.subscribe((x) => this.zipCodeGetStatus(x, callback));
    }

    private zipCodeGetStatus(status: DataSourceStatus, callback: any = null) {
        if (status === DataSourceStatus.Ready) {
            let result: ZipCodeType = cloneDeep(this.dsZipCode.objectNode);
            result.Zip_Lookup_Status = 'Valid';
            result.Zip_Lookup_Message = '';
            callback(result);
        }
        if (status === DataSourceStatus.Error) {
            let result: ZipCodeType = cloneDeep(this.dsZipCode.objectNode);
            result.Zip_Lookup_Status = this.dsZipCode._replyCode == -4027 ? 'Invalid' : 'Error';
            result.Zip_Lookup_Message = this.dsZipCode._replyMessage;
            callback(result);
        }
    }
}
